import styled from 'styled-components'
import { media } from '../../theme/breakpoints'

export const BaseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;

    ${media.tabletAndBelow} {
        min-height: 44px;
        min-width: 44px;
    }
`
